var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPracticeassessment(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 40,
    viewBox: "0 0 63 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.84076 2.70415L58.6878 2.60509C59.454 2.60381 60.0784 3.34352 60.0784 4.25305L60.1354 39.7556C60.8786 39.3825 61.6969 39.1085 62.5904 38.94L62.5346 4.24791C62.5334 1.90268 60.8046 -0.00385354 58.6866 5.84908e-06L3.83954 0.097777C1.72034 0.101636 -0.00363133 2.01332 5.7443e-06 4.35983L0.0557741 39.506C0.935946 39.578 1.76035 39.7401 2.51322 40L2.45503 4.35597C2.45503 3.44644 3.07455 2.70544 3.84076 2.70415Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7871 16.7679L17.4533 29.0755L14.0248 25.6664L6.20752 37.0567L8.53161 39.0379L13.421 32.1501L17.8158 35.9272L26.1411 23.5849L36.3867 32.4383L48.9795 17.2979L56.4112 23.3443L55.3262 3.38867L37.2342 7.4436L43.5263 12.7207L35.2205 24.4288L25.7871 16.7679Z",
    fill: "#00B849"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPracticeassessment);
export default __webpack_public_path__ + "static/media/practice assessment.19c5ae5a1570acc51cef6a44478e9986.svg";
export { ForwardRef as ReactComponent };